var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{attrs:{"sitekey":_vm.site_key,"loadRecaptchaScript":true},on:{"verify":_vm.onVerify,"error":_vm.onError,"expired":_vm.onExpire}})}
var staticRenderFns = []

export { render, staticRenderFns }